import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import * as SecureLS from "secure-ls";
import { GlobalService } from "src/app/services/global.service";
import { StorageService } from "../../services/storage.service";
import Swal from "sweetalert2";
import { IsPointV2, AppLogo2, ClgLogo } from "src/app/app.config";
@Component({
  selector: "app-forgot-password",
  templateUrl: "./forgot-password.component.html",
  styleUrls: ["./forgot-password.component.css"],
})
export class ForgotPasswordComponent implements OnInit {
  forgetpass: any;
  forgetForm: FormGroup;
  submitted = false;
  appLogo = AppLogo2;
  clgLogo = ClgLogo;
  private ls = new SecureLS({ encodingType: "aes" });
  constructor(
    private storageService: StorageService,
    private fb: FormBuilder,
    public router: Router,
    public globalService: GlobalService,
    private spinner: NgxSpinnerService
  ) {}
  ngOnInit(): void {
    this.forgetForm = this.fb.group({
      login_id: ["", [Validators.required]],
    });
  }
  get validate() {
    return this.forgetForm.controls;
  }
  async forgetPass(form: FormGroup) {
    this.submitted = true;
    if (this.forgetForm.invalid) {
      return;
    }
    this.spinner.show();
    let formdata = {
      username: form.value.login_id,
    };

    this.forgetpass = await this.globalService.create(
      "user/forgot-password",
      formdata,
      IsPointV2
    );

    let compData = this.forgetpass["content"];

    if (this.forgetpass) {
      if (this.forgetpass["status"] === 200) {
        Swal.fire("Success", this.forgetpass["message"], "success");

        this.ls.set("user_id", compData.user_id);
        this.ls.set("role", compData.role_id);
        this.router.navigate(["/otp-verify", { id: 1 }]);
      } else if (this.forgetpass["status"] === 400) {
        Swal.fire("Error!", this.forgetpass["error"].message, "error");
      } else {
        Swal.fire("Error!", "Something Went Wrong", "error");
      }
    }
    this.spinner.hide();
  }
}
